import { render, staticRenderFns } from "./MdEditTableCN.vue?vue&type=template&id=480589fc&"
import script from "./MdEditTableCN.vue?vue&type=script&lang=js&"
export * from "./MdEditTableCN.vue?vue&type=script&lang=js&"
import style0 from "./MdEditTableCN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports